import React from "react";
import { Formik } from "formik";

import * as Yup from "yup";
import ErrorMessage from "../components/ErrorMessage";

import authClient from "../api/authClient";
import { useContext } from "react";
import AuthContext from "../auth/context";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const validationSchema = Yup.object().shape({
  login: Yup.string().required("Le login est obligatoire"),
  password: Yup.string().required("Le mot de passe est obligatoire"),
});

const Login = () => {
  document.body.className = "authentication-bg pb-0";
  const authContext = useContext(AuthContext);

  const validerFormulaire = async (values) => {
    //console.log(values);
    const retour = await authClient.login(values, (progress) =>
      console.log(progress)
    );

    if (retour.ok) {
      console.log("data", retour.data);

      localStorage.setItem("currentUser", JSON.stringify(retour.data));
      authContext.setUser(retour.data);

      document.body.className = "";

      window.location = "/";
    } else {
      toast.error("Login ou mot de passe incorrect");
    }
  };

  return (
    <div className="auth-fluid">
      <ToastContainer />
      <div className="auth-fluid-form-box">
        <div className="align-items-center d-flex h-100">
          <div className="card-body">
            <div className="auth-brand text-center text-lg-center">
              <a href="#" className="logo-dark">
                <span>
                  <img
                    src="assets/images/Logo-Mobiclean.png"
                    alt=""
                    style={{ height: "30vh" }}
                  />
                </span>
              </a>
            </div>

            <h4 className="mt-0">Authentification</h4>
            <p className="text-muted mb-4">
              Veuillez entrer votre identifiant et votre mot de passe pour
              accéder à votre compte
            </p>

            <Formik
              initialValues={{
                login: "",
                password: "",
              }}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                validerFormulaire(values);
              }}
            >
              {({
                handleChange,
                handleSubmit,
                errors,
                setFieldTouched,
                touched,
                values,
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="inputEmailAddress">Identifiant</label>

                    <input
                      value={values["login"]}
                      onChange={handleChange("login")}
                      onBlur={() => setFieldTouched("login")}
                      className="form-control "
                      id="inputEmailAddress"
                      type="text"
                      autoComplete="off"
                      placeholder="Entrez votre identifiant"
                    />
                    <ErrorMessage
                      error={errors.login}
                      visible={touched.login}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Mot de passe</label>

                    <input
                      value={values["password"]}
                      onChange={handleChange("password")}
                      onBlur={() => setFieldTouched("password")}
                      className="form-control"
                      id="inputPassword"
                      type="password"
                      placeholder="Entrez votre mot de passe"
                    />
                    <ErrorMessage
                      error={errors.password}
                      visible={touched.password}
                    />
                  </div>
                  <div className="form-group mb-0 text-center">
                    <button
                      className="btn btn-primary btn-block"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      <i className="mdi mdi-login"></i> Log In
                    </button>
                  </div>
                </form>
              )}
            </Formik>

            <footer className="footer footer-alt"></footer>
          </div>
        </div>
      </div>
      <div className="auth-fluid-right text-center">
        <div className="auth-user-testimonial d-none">
          <h2 className="mb-3">I love the color!</h2>
          <p className="lead">
            <i className="mdi mdi-format-quote-open"></i> It's a elegent
            templete. I love it very much! .{" "}
            <i className="mdi mdi-format-quote-close"></i>
          </p>
          <p>- Hyper Admin User</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
